export default __webpack_public_path__ + "static/07-522619c8b38209e51791bcde0ac39c41.png";